import { motion } from "framer-motion";
import { MapPin, FileCheck, BadgeCheck } from "lucide-react";
const steps = [
  { icon: MapPin, step: "01", title: "Choose Destination", description: "Select your desired country. See exact requirements, pricing, and processing times instantly." },
  { icon: FileCheck, step: "02", title: "Submit Documents", description: "Upload your documents securely. Our experts review every detail for a smooth application." },
  { icon: BadgeCheck, step: "03", title: "Get Approved", description: "Receive your visa digitally. Track your application in real-time from submission to approval." },
];
export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 md:py-28 px-6 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
          <span className="text-xs tracking-widest uppercase font-semibold text-blue-600 mb-3 block">Simple Process</span>
          <h2 className="heading-font text-3xl md:text-4xl font-bold text-slate-900">How It Works</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-14 left-[20%] right-[20%] h-px border-t-2 border-dashed border-blue-100" />
          {steps.map((s, i) => (
            <motion.div key={s.step} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.15 }} className="text-center relative" data-testid={`step-${s.step}`}>
              <div className="relative inline-flex mb-6">
                <div className="w-14 h-14 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-blue-600" />
                </div>
                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-[10px] font-bold">{s.step}</span>
              </div>
              <h3 className="heading-font text-lg font-semibold text-slate-900 mb-2">{s.title}</h3>
              <p className="text-sm text-slate-500 max-w-xs mx-auto">{s.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
